var map = {
	"./viasport-logo-black.png": 997,
	"./viasport-logo-dk.png": 1064,
	"./viasport-logo-fi.png": 1065,
	"./viasport-logo-no.png": 1066,
	"./viasport-logo-se-black.png": 953,
	"./viasport-logo-se.png": 1067
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 885;


//////////////////
// WEBPACK FOOTER
// ./assets ^\.\/viasport\-logo\-.*\.png$
// module id = 885
// module chunks = 0 1 2